
export default function About() {
  return (
    <section id="about" className="py-20 bg-gradient-to-b from-white to-pink-50/30">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Sobre el Dr. Germán Delgadillo Espejo
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-pink-400 to-blue-400 mx-auto rounded-full"></div>
          </div>

          <div className="bg-white rounded-3xl shadow-xl p-8 lg:p-12">
            <div className="grid lg:grid-cols-3 gap-8 items-center">
              <div className="lg:col-span-1">
                <img
                  src="https://static.readdy.ai/image/f15b91f1c882dc85fb9b8fcd7db718c1/1d328c8c83b4bac006140a4a0b39136e.png"
                  alt="Dr. Germán Delgadillo Espejo"
                  className="rounded-2xl shadow-lg w-full object-cover object-top"
                />
              </div>

              <div className="lg:col-span-2 space-y-6">
                <p className="text-lg text-gray-700 leading-relaxed">
                  Médico Cirujano Partero egresado de la Universidad de Guadalajara y Especialista en Ginecología por la Universidad Veracruzana. Con diplomados en Colposcopía y Tracto Genital Inferior, y Fisiología Obstétrica y Ultrasonografía Doppler.
                </p>

                <p className="text-lg text-gray-700 leading-relaxed">
                  Con amplia experiencia en embarazo, partos, cesáreas, detección de cáncer ginecológico, VPH e infertilidad. El Dr. Delgadillo combina tecnología de vanguardia con un trato humano y empático, ofreciendo atención personalizada las 24 horas del día.
                </p>

                {/* Información de cédulas profesionales */}
                <div className="bg-gradient-to-r from-yellow-50 to-amber-50 rounded-xl p-4 border border-yellow-200">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <div className="flex items-center space-x-3">
                      <div className="w-8 h-8 flex items-center justify-center">
                        <i className="ri-file-text-line text-xl text-amber-600"></i>
                      </div>
                      <div>
                        <div className="font-semibold text-gray-900 text-sm">Cédula Profesional</div>
                        <div className="text-amber-700 font-medium">5131559</div>
                      </div>
                    </div>
                    <div className="flex items-center space-x-3">
                      <div className="w-8 h-8 flex items-center justify-center">
                        <i className="ri-medal-line text-xl text-amber-600"></i>
                      </div>
                      <div>
                        <div className="font-semibold text-gray-900 text-sm">Cédula de Especialidad</div>
                        <div className="text-amber-700 font-medium">8192590</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-r from-pink-50 to-blue-50 rounded-2xl p-6 border border-pink-100">
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">Mi filosofía de atención</h3>
                  <p className="text-gray-700 leading-relaxed">
                    "Mi compromiso es acompañar a cada mujer en todas las etapas de su vida, desde la adolescencia hasta la menopausia, brindando cuidado integral con tecnología avanzada y un enfoque completamente humano. La confianza y disponibilidad total son la base de mi práctica médica."
                  </p>
                </div>

                <div className="grid grid-cols-2 gap-4 pt-4">
                  <div className="flex items-start space-x-3">
                    <div className="w-8 h-8 flex items-center justify-center">
                      <i className="ri-award-line text-2xl text-pink-500"></i>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-900">Especialista Certificado</div>
                      <div className="text-sm text-gray-600">Universidad Veracruzana</div>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-8 h-8 flex items-center justify-center">
                      <i className="ri-time-line text-2xl text-blue-400"></i>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-900">Disponibilidad</div>
                      <div className="text-sm text-gray-600">Urgencias 24/7</div>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-8 h-8 flex items-center justify-center">
                      <i className="ri-microscope-line text-2xl text-pink-500"></i>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-900">Tecnología</div>
                      <div className="text-sm text-gray-600">Ultrasonido Doppler</div>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-8 h-8 flex items-center justify-center">
                      <i className="ri-heart-pulse-line text-2xl text-blue-400"></i>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-900">Especialidades</div>
                      <div className="text-sm text-gray-600">Colposcopía y VPH</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Sección de Instituciones */}
            <div className="mt-12 pt-8 border-t border-gray-100">
              <h3 className="text-2xl font-semibold text-gray-900 text-center mb-8">
                Formación Académica y Certificaciones
              </h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                <div className="text-center">
                  <img
                    src="https://static.readdy.ai/image/f15b91f1c882dc85fb9b8fcd7db718c1/97873fa2078bedf748cd8cc399f75e70.jpeg"
                    alt="Universidad de Guadalajara"
                    className="w-20 h-20 mx-auto mb-3 object-contain"
                  />
                  <p className="text-sm font-medium text-gray-700">Universidad de Guadalajara</p>
                  <p className="text-xs text-gray-500">Médico Cirujano Partero</p>
                </div>
                <div className="text-center">
                  <img
                    src="https://static.readdy.ai/image/f15b91f1c882dc85fb9b8fcd7db718c1/234661520924410f1a3a9898ed9ac469.jpeg"
                    alt="Universidad Veracruzana"
                    className="w-20 h-20 mx-auto mb-3 object-contain"
                  />
                  <p className="text-sm font-medium text-gray-700">Universidad Veracruzana</p>
                  <p className="text-xs text-gray-500">Especialista en Ginecología</p>
                </div>
                <div className="text-center">
                  <img
                    src="https://static.readdy.ai/image/f15b91f1c882dc85fb9b8fcd7db718c1/e1ca7f2a3e885978976533400765a423.png"
                    alt="Diplomado Colposcopía"
                    className="w-20 h-20 mx-auto mb-3 object-contain"
                  />
                  <p className="text-sm font-medium text-gray-700">Certificado</p>
                  <p className="text-xs text-gray-500">El Consejo Mexicano de Ginecología y Obstetricia A.C.</p>
                </div>
                <div className="text-center">
                  <img
                    src="https://static.readdy.ai/image/f15b91f1c882dc85fb9b8fcd7db718c1/2b33029ef02c11db388769d40d2d22d0.png"
                    alt="Diplomado Ultrasonografía"
                    className="w-20 h-20 mx-auto mb-3 object-contain"
                  />
                  <p className="text-sm font-medium text-gray-700">Alta especialización</p>
                  <p className="text-xs text-gray-500">Fisiología Obstétrica y Ultrasonografia Doppler</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
